<template>
  <div class="events-page-layout d-flex">
    <CategorySelectMenu />
    <MobileHeader
      :selected-member="user">
      <CategoryCheckboxList />
    </MobileHeader>
    <div class="flex-grow-1">
      <router-view :key="$route.fullPath" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MobileHeader from '@/components/parts/MobileHeader'
import CategoryCheckboxList from '@/components/view/CategoryCheckboxList'
import CategorySelectMenu from '@/components/view/events_page_layout/CategorySelectMenu.vue'

export default {
  components: { CategorySelectMenu, MobileHeader, CategoryCheckboxList },
  computed: {
    ...mapState('auth', ['user']),
  }
}
</script>

<style lang="scss" scoped>
</style>
